import { ReactNode } from 'react';
import { clsx } from 'clsx';

type AuthPageShellProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Shared auth layout: gradient mesh, soft grid, drifting blobs (CSS-only motion).
 */
export function AuthPageShell({ children, className }: AuthPageShellProps) {
  return (
    <div
      className={clsx(
        'relative min-h-screen overflow-x-hidden bg-background text-foreground',
        className
      )}
    >
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-slate-50 via-background to-primary/[0.09] dark:from-[hsl(222_47%_5%)] dark:via-background dark:to-primary/15"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,hsl(var(--border)/0.12)_1px,transparent_1px),linear-gradient(to_bottom,hsl(var(--border)/0.12)_1px,transparent_1px)] bg-[length:56px_56px] opacity-60 [mask-image:radial-gradient(ellipse_75%_60%_at_50%_35%,black,transparent)] dark:opacity-40"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -left-40 -top-32 h-[min(32rem,90vw)] w-[min(32rem,90vw)] rounded-full bg-primary/20 blur-[100px] auth-blob-drift"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-36 top-[20%] h-[min(28rem,85vw)] w-[min(28rem,85vw)] rounded-full bg-primary/12 blur-[90px] auth-blob-drift-delayed"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute bottom-0 left-[15%] h-48 w-48 rounded-full bg-amber-400/15 blur-[72px] dark:bg-amber-500/10"
        aria-hidden
      />

      <div className="relative z-10">{children}</div>
    </div>
  );
}
